import React, { useEffect, useState } from "react";
import { addRoleService, associatedRoleServices, deleteUserRole, getUserRoleService, getUserTypeRl, getUserTypeService, removeRoleService } from "../../../store/actions/security/userRoleAction";
import { Form, message, Breadcrumb, Card, Drawer, useDispatch, Switch, useSelector, PlusSquareOutlined, CloseSquareOutlined, Input, Button, Divider, Radio, DeleteFilled, EditFilled, SearchOutlined, UserAddOutlined, Tree, Popconfirm, Tooltip } from '../../AntComponent';
const { TreeNode } = Tree;

export default function UserRoles() {

  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { roleTypeData, utypeData, roleData, rTypeData, success3, success5,success7,delUserInfo,addRoleInfo, serviceInfo } = useSelector(state => state.userRole);
  const { profileInfo } = useSelector(state => state.userPrf);
  const tenantID = profileInfo?.data?.appUser?.tenantID;
  const productID = profileInfo?.data?.tenantDetail?.kProductID;
  const [rowData, setRowData] = useState([]);
  const UserTypeID = rowData?.key;
  const [nodeType, setNodeType] = useState("parent");
  const [newNode, setNewNode] = useState(false);
  const [open, setOpen] = useState(false);
  const [parentID, setParentID] = useState(0);
  const [reportID, setReportID] = useState(0);
  const [roleID, setRoleID] = useState(0);
  const [checkedSelectedParent, setCheckedParentSelected] = useState([]);
  const [checkedSelectedChild, setCheckedSelectedChild] = useState([]);
  const [roleService, setRoleService] = useState([]);
  const [roleServices2,setRoleServices2] = useState([]);
  const [showSuccessmsg, setShowsuccessmsg] = useState(false);
  const successmsg = showSuccessmsg ? success3 : null;
  const [showSuccessmsg1, setShowsuccessmsg1] = useState(false);
  const successmsg1 = showSuccessmsg1 ? success5 : null;
  const [showSuccessmsg2, setShowsuccessmsg2] = useState(false);
  const successmsg2 = showSuccessmsg2 ? success7 : null;
  const [pathName, setPathName] = useState("");
  const [checkedKeys, setCheckedKeys] = useState([]);
  const [hasExecuted, setHasExecuted] = useState(true);
  // const [assService, setAssService] = useState([]);
  // console.log(newNode, "node")
  // console.log(nodeType, "nodetype")
  // console.log(rTypeData, "user to menu servue")
  // console.log(roleService, "roleservice1 parent")
  // console.log(roleServices2, "roleservice2 child")

  // console.log(utypeData, "utypedata parent")
  // console.log(rTypeData, "rype child")
  const [testSrv, setTestSrv] = useState([]);
  useEffect(() => {
    getUserRoleType();
  }, [dispatch, tenantID]);
  // const userService=[];
  const userService = roleData?.data.map((item) => {
    if (item.roles.length == 0) {
      return (
        {
          title: item.userType,
          key: item.userTypeID,
          type: "parent",
          desc: item.description,
          RoleCategory:"",
          parent: 0,
          parentName: item.userType,
          reportId: 0,
          children: []
        }
      )
    } else {
      return (
        {
          title: item.commonName,
          key: item.userTypeID,
          type: "parent",
          desc: item.description,
          RoleCategory:"",
          reportId: 0,
          parent: 0,
          parentName: item.userType,
          children: item.roles.map((itm) => {
            if (itm.roles.length == 0) {
              return (
                {
                  title: itm.commonName,
                  key: itm.roleId,
                  desc: itm.roleDescription,
                  RoleCategory:itm.roleCategory,
                  parent: item.userTypeID,
                  parentName: item.userType + "->" + itm.commonName,
                  reportId: 0,
                  type: "child",
                  children: []
                }
              )
            } else {
              return (
                {
                  title: itm.commonName,
                  key: itm.roleId,
                  desc: itm.roleDescription,
                  RoleCategory:itm.roleCategory,
                  parent: item.userTypeID,
                  roleId: item.roleId,
                  parentName: item.userType + "->" + itm.commonName,
                  reportId: 0,
                  type: "sub-parent",
                  children: itm.roles.map((val) => {
                    if (val.roles == null) {
                      return (
                        {
                          title: val.commonName,
                          key: val.roleId,
                          desc: val.roleDescription,
                          RoleCategory:val.roleCategory,
                          parent: item.userTypeID,
                          parentName: item.userType + "->" + itm.commonName + "->" + val.commonName,
                          reportId: itm.roleId,
                          type: "child",
                          children: []
                        }
                      )
                    } else {
                      return (
                        {
                          title: val.commonName,
                          key: val.roleId,
                          desc: val.roleDescription,
                          RoleCategory:val.roleCategory,
                          parent: item.userTypeID,
                          parentName: item.userType + "->" + itm.commonName + "->" + val.commonName,
                          reportId: itm.roleId,
                          type: "sub-parent",
                          children: val?.roles.map((val1) => {
                            // if(val1.roles.length==0){
                            return (
                              {
                                title: val1.commonName,
                                key: val1.roleId,
                                desc: val1.roleDescription,
                                RoleCategory:val1.roleCategory,
                                parent: item.userTypeID,
                                parentName: item.userType + "->" + itm.commonName + "->" + val.commonName + "->" + val1.commonName,
                                reportId: val.roleId,
                                type: "child",
                                children: []
                              }
                            )
                            // }else{
                            //   // if(val1.roles.length==0){
                            //   return (
                            //     {
                            //       title: val1.commonName,
                            //       key: val1.roleId,
                            //       desc: val1.roleDescription,
                            //       parent: item.userTypeID,
                            //       parentName: item.userType + "->" + itm.commonName + "->" + val.commonName +"->"+val1.commonName,
                            //       reportId: val.roleId,
                            //       type: "child",
                            //       children: []
                            //     }
                            //   )

                            // }

                          })
                        }
                      )
                    }
                  })
                }
              )
            }
          })
        }
      )
    }
  }
  );
  useEffect(() => {
    let c = [];
    if (serviceInfo?.data) {
      for (let i = 0; i < serviceInfo?.data.length; i++) {
        if (serviceInfo.data[i].isAssociate == true && serviceInfo.data[i].subMenu == 0) {
          c.push(serviceInfo.data[i].entServiceId.toString());

        } else {
          if (serviceInfo.data[i].isAssociate == true) {
            c.push(serviceInfo.data[i].entServiceId.toString());
            let d = serviceInfo.data[i].subMenu;
            for (let j = 0; j < d.length; j++) {
              if (d[j].isAssociate == true) {
                c.push(d[j].entServiceId.toString());
              }
            }
          }
        }
      }
    }
    setCheckedKeys(c);
  }, [serviceInfo]);

  const filteredArray = serviceInfo?.data?.filter(
    (item) => item.isAssociate && item.subMenu !== null
  );
  useEffect(() => {
    let c = [];
    let f = [];
    if (rTypeData?.data) {
      for (let i = 0; i < rTypeData?.data.length; i++) {
        if (rTypeData?.data[i]?.subMenu == 0) {
          c.push(rTypeData.data[i].entServiceId?.toString());
          f.push({
            title: rTypeData.data[i].serviceName,
            key: rTypeData.data[i].entServiceId,
            type: "parent",
            children: []
          })

        } else {
          // if(utypeData.data[i].isAssociate==true){
          c.push(rTypeData.data[i].entServiceId.toString());
          let d = rTypeData.data[i].subMenu;
          let b = [];
          for (let j = 0; j < d.length; j++) {
              c.push(d[j].entServiceId.toString());
              b.push({
              title: d[j].serviceName,
              key: d[j].entServiceId,
              type: "child",
              children: []})
          }
          f.push({
              title: rTypeData.data[i].serviceName,
              key: rTypeData.data[i].entServiceId,
              type: "parent",
              children:b
          })
        //   for (let j = 0; j < d.length; j++) {
           
        //     c.push(d[j].entServiceId.toString());
           
        //     f.push({
        //       title: rTypeData?.data[i]?.serviceName,
        //       key: rTypeData?.data[i]?.entServiceId,
        //       type: "parent",
        //       children: [
        //         {
        //           title: d[j].serviceName,
        //           key: d[j].entServiceId,
        //           type: "child",
        //           children: []
        //         }
        //       ]
        //     })
        //   }
          
        }
      }
    }
    setCheckedSelectedChild(c);
    let es = [];
    setRoleServices2([]);
    for (let k = 0; k < f.length; k++) {
      es.push(f[k]);
    }
    setRoleServices2(es);

  }, [rTypeData]);

  // useEffect(() => {
  //   const filteredArray1 = rTypeData?.data.filter(
  //     (item) => item.entServiceId
  //   );
  //   let data = rTypeData?.data;
  //   let c = [];
  //   for (let i = 0; i < data?.length; i++) {
  //     if (data[i].isAssociate == true) {
  //       if(data[i].subMenu.length>0){
  //         for(let j=0;j<data[i].subMenu.length;j++){
  //           if(data[i].subMenu[j].isAssociate==true){
  //             c.push(data[i].subMenu[j].entServiceId);
  //           }
  //         }
  //       }
  //       c.push(data[i].entServiceId);
  //     }
  //   }
  //   console.log("CCCCCCCCCCCc",filteredArray1);
  //   setCheckedSelectedChild(filteredArray1);
  // }, [rTypeData]);
  // useEffect(() => {
  //   const filteredArray1 = utypeData?.data.filter(
  //     (item) => item.isAssociate && item.subMenu !== null
  //   );
  //   setCheckedParentSelected(filteredArray1);
  //   console.log("FIKLLLLLLLLLLLLL PAREMT",utypeData)
  // }, [utypeData]);

  // utypeData
  
  // const assService = filteredArray?.map((item) => {
  //   if (item.isAssociate) {
  //     if (item.subMenu.length > 0) {
  //       return (
  //         {
  //           title: item.serviceName,
  //           key: item.entServiceId,
  //           type: "parent",
  //           children: item?.subMenu.map((itm) => {
  //             return (
  //               {
  //                 title: itm.serviceName,
  //                 key: itm.entServiceId,
  //                 type: "child",
  //                 // isLeaf:true
  //                 // children: []
  //               }
  //             )
  //           })
  //         }

  //       )
  //     }
  //     else {
  //       // if(item.isAssociate==true){
  //       return (
  //         {
  //           title: item.serviceName,
  //           key: item.entServiceId,
  //           type: "parent",
  //           children: []
  //         }
  //       )
  //       // }
  //     }
  //   } else {
  //     console.log("dkfjla", item.isAssociate)
  //   }
  // });
  const assService = filteredArray?.map((item) => {
    if (item?.isAssociate) {
      const hasAssociateInSubMenu = item?.subMenu?.some((itm) => itm.isAssociate);
  
      if (hasAssociateInSubMenu) {
        const children = item.subMenu
          .filter((itm) => itm.isAssociate)
          .map((itm) => {
            return {
              title: itm.serviceName,
              key: itm.entServiceId,
              type: "child",
            };
          });
  
        return {
          title: item.serviceName,
          key: item.entServiceId,
          type: "parent",
          children: children,
        };
      } else {
        return {
          title: item.serviceName,
          key: item.entServiceId,
          type: "parent",
          children: [],
        };
      }
    } else {
      console.log("dkfjla", item.isAssociate);
    }
  });
  // console.log(assService, "assocaited sevice")
  useEffect(() => {
    let c = [];
    let f = [];
    if (utypeData?.data) {
      for (let i = 0; i < utypeData?.data.length; i++) {
        if (utypeData.data[i].subMenu == 0) {
          c.push(utypeData.data[i].entServiceId.toString());
          f.push({
            title: utypeData.data[i].serviceName,
            key: utypeData.data[i].entServiceId,
            type: "parent",
            children: []
          })

        } else {
          // if(utypeData.data[i].isAssociate==true){
          c.push(utypeData.data[i].entServiceId.toString());
          let d = utypeData.data[i].subMenu;
          let b = [];
          for (let j = 0; j < d.length; j++) {
              c.push(d[j].entServiceId.toString());
              b.push({
              title: d[j].serviceName,
              key: d[j].entServiceId,
              type: "child",
              children: []})
          }
          f.push({
              title: utypeData.data[i].serviceName,
              key: utypeData.data[i].entServiceId,
              type: "parent",
              children:b
          })
          // for (let j = 0; j < d.length; j++) {
          //   // if(d[j].isAssociate==true){
          //   c.push(d[j].entServiceId.toString());
          //   // }
          //   f.push({
          //     title: utypeData.data[i].serviceName,
          //     key: utypeData.data[i].entServiceId,
          //     type: "parent",
          //     children: [
          //       {
          //         title: d[j].serviceName,
          //         key: d[j].entServiceId,
          //         type: "child",
          //         children: []
          //       }
          //     ]
          //   })
          // }
          // }
        }
      }
    }
    setCheckedParentSelected(c);
    let es = [];
    setRoleService([]);
    // setRoleServices2([]);
    for (let k = 0; k < f.length; k++) {
      es.push(f[k]);
    }
    setRoleService(es);
    // setRoleServices2(es);

  }, [utypeData]);

  //   let c = [];
  //   let f = [];
  //   if (serviceInfo?.data) {
  //     for (let i = 0; i < serviceInfo?.data.length; i++) {
  //       if (serviceInfo.data[i].subMenu == 0) {
  //         // c.push(serviceInfo.data[i].entServiceId.toString());
  //         f.push({
  //           title: serviceInfo.data[i].serviceName,
  //           key: serviceInfo.data[i].entServiceId,
  //           type: "parent",
  //           children: []
  //         })

  //       } else {
  //         // if(utypeData.data[i].isAssociate==true){
  //         // c.push(serviceInfo.data[i].entServiceId.toString());
  //         let d = serviceInfo.data[i].subMenu;
  //         for (let j = 0; j < d.length; j++) {
  //           // if(d[j].isAssociate==true){
  //           // c.push(d[j].entServiceId.toString());
  //           // }
  //           f.push({
  //             title: serviceInfo.data[i].serviceName,
  //             key: serviceInfo.data[i].entServiceId,
  //             type: "parent",
  //             children: [
  //               {
  //                 title: d[j].serviceName,
  //                 key: d[j].entServiceId,
  //                 type: "child",
  //                 children: []
  //               }
  //             ]
  //           })
  //         }
  //         // }
  //       }
  //     }
  //   }
  //   // setCheckedSelectedChild(c);
  //   let es = [];
  //   setAssService([]);
  //   for (let k = 0; k < f.length; k++) {
  //     es.push(f[k]);
  //   }
  //   setAssService(es);

  // }, [serviceInfo]);


  // useEffect(() => {
  //   let c = [];
  //   let f = [];
  //   if (rTypeData?.data) {
  //     for (let i = 0; i < rTypeData?.data.length; i++) {
  //       if (rTypeData.data[i].subMenu == 0) {
  //         c.push(rTypeData.data[i].entServiceId.toString());
  //         f.push({
  //           title: rTypeData.data[i].serviceName,
  //           key: rTypeData.data[i].entServiceId,
  //           type: "parent",
  //           children: []
  //         })

  //       } else {
  //         // if(utypeData.data[i].isAssociate==true){
  //         c.push(rTypeData.data[i].entServiceId.toString());
  //         let d = rTypeData.data[i].subMenu;
  //         for (let j = 0; j < d.length; j++) {
  //           // if(d[j].isAssociate==true){
  //           c.push(d[j].entServiceId.toString());
  //           // }
  //           f.push({
  //             title: rTypeData.data[i].serviceName,
  //             key: rTypeData.data[i].entServiceId,
  //             type: "parent",
  //             children: [
  //               {
  //                 title: d[j].serviceName,
  //                 key: d[j].entServiceId,
  //                 type: "child",
  //                 children: []
  //               }
  //             ]
  //           })
  //         }
  //         // }
  //       }
  //     }
  //   }
  //   setCheckedParentSelected(c);
  //   let es = [];
  //   setTestSrv([]);
  //   for (let k = 0; k < f.length; k++) {
  //     es.push(f[k]);
  //   }
  //   setTestSrv(es);

  // }, [rTypeData]);

  const roleService2 = utypeData?.data.map((item) => {
    if (item.subMenu.length == 0) {
      return (
        {
          title: item.serviceName,
          key: item.entServiceId,
          type: "parent",
          children: []

        }
      )
    } else {
      return (
        {
          title: item.serviceName,
          key: item.entServiceId,
          type: "parent",
          children: item?.subMenu.map((itm) => {
            return (
              {
                title: itm.serviceName,
                key: itm.entServiceId,
                type: "child",
                // isLeaf:true
                // children: []
              }
            )
          })
        }
      )
    }
  });

  const checkService = serviceInfo?.data?.map((item) => {
    if (item.subMenu.length == 0) {
      return (
        {
          title: item.serviceName,
          key: item.entServiceId,
          type: "parent",
          parent: 0,
          children: []

        }
      )
    } else {
      return (
        {
          title: item.serviceName,
          key: item.entServiceId,
          type: "parent",
          parent: 0,
          children: item?.subMenu?.map((itm) => {
            return (
              {
                title: itm.serviceName,
                key: itm.entServiceId,
                parent: item.entServiceId,
                type: "child",
                // isLeaf:true
                // children: []
              }
            )
          })
        }
      )
    }
  });

  function getUTypeService(id) {
    dispatch(getUserTypeService(id));
  }

  function getURoleService(key) {
    dispatch(getUserRoleService(key));
  }
  // const defaultUserRole = () =>{
  //   // console.log("Entered")
  //   if (roleData?.data) {
  //     getUTypeService(roleData?.data[0]?.userTypeID);
  //     let d = roleData.data[0]
  //     setRowData(d);
  //   }
  // }
  useEffect(() => {
      if (roleData?.data && hasExecuted) {
        getUTypeService(roleData?.data[0]?.userTypeID);
        let d = roleData.data[0]
        setRowData(d);
        setHasExecuted(false);
      }
  }, [roleData]);

  const renderTitle = (node) => {
    const isLeafNode = node.type == "child" ? true : false;
    const closeIcon = isLeafNode ? <CloseSquareOutlined className='close-icon bg-danger text-white' /> : null;
    const pulsIcon = isLeafNode ? <PlusSquareOutlined className='plus-icon bg-primary text-white' /> : null;

    return (

      <div className="d-flex w-100" key={node.key}>
        <div className="col-auto" onClick={() => clickTree(node)}>{node.title}</div>
        <div className="col-auto ms-auto" >
          <span className="text-dark"> <Popconfirm
            placement="topLeft"
            title="Are you sure to remove this role?"
            // description="Delete the patient"
            onConfirm={() => removeRole(node.key)}
            okText="Yes"
            cancelText="No"
          >
            {/* <Tooltip title="Delete" className='mt-0'> */}
            {closeIcon}
            {/* </Tooltip> */}
          </Popconfirm></span>
          <span className="ms-2" onClick={() => addChildNode(node)}>{pulsIcon}</span>
        </div>
      </div>
    );
  };
  const renderTitle3 = (node) => {

    return (

      <div className="d-flex w-100" key={node.key}>
        <div className="col-md-6 p-2 assTreeWdh" onClick={() => clickTree(node)}>{node.title}</div>
        <div className="col ms-auto" >
          <div className="bg-white desc-box border row pt-2 "></div>
        </div>
      </div>
    );
  };

  const removeRole = (id) => {
    let ids = `${tenantID}/${id}`
    dispatch(deleteUserRole(ids));
    setShowsuccessmsg1(true);
  }

  const renderTreeNodes = (data) =>
    data.map((item) => {
      if (item.children) {
        const hasChildren = item.children.length > 0;
        const isLastChild = !hasChildren;
  
        return (
          <TreeNode
            className={`${item.type} bg-white`}
            key={item.key}
            title={
              <div className="row w-100 m-0">
                <div className="col me-2" onClick={() => clickTree(item)}>
                  {item.type === "parent" ? <span className="fw-500">User Type:</span> : ""} {item.title}
                </div>
                <div className="col-auto ms-auto pe-1">
                  <Tooltip title="Add User Role" className='mt-0'>
                    <PlusSquareOutlined className="plus-icon bg-primary text-white " onClick={() => addChildNode(item)} />
                  </Tooltip>
                  {isLastChild && (item.type === "sub-parent" || item.type === "child") ? (
                    <Popconfirm
                      placement="topLeft"
                      title="Are you sure to remove this role?"
                      onConfirm={() => removeRole(item.key)}
                      okText="Yes"
                      cancelText="No"
                    >
                    <span><Tooltip title="Delete User Role" className='mt-0'><CloseSquareOutlined className='close-icon bg-danger text-white ms-1' /></Tooltip></span> 
                    </Popconfirm>
                  ) : null}
                </div>
              </div>
            }
          >
            {renderTreeNodes(item.children)}
          </TreeNode>
        );
      }

      return (<TreeNode key={item.key} className={`${item.type}`} title={renderTitle(item)} />);
    });

  const renderTreeNodes3 = (data) =>
    data.map((item) => {
      if (item.children) {
        return (
          <TreeNode className={`${item.type} bg-white`}
            key={item.key}
            title={
              <div className="row w-100 m-0" >
                <div className="col-md-6 p-2 assTreeWdh" >
                  {item.title}
                </div>
                <div className="col ms-auto pe-1">
                  <div className="bg-white desc-box border row pt-2 "></div>
                </div>
              </div>
            }
          >
            {renderTreeNodes3(item.children)}
          </TreeNode>
        );
      }

      return (<TreeNode key={item.key} className={`${item.type} p-2`} title={renderTitle3(item)} />);
    });
  const renderTitle1 = (node) => {
    return (

      <div className="row w-100 m-0" key={node.key}>
        <div className="col-md-6 p-2 pe-0 "><span className="">{node.title}</span></div>
        <div className="col ms-auto">
          <div className="bg-white desc-box border row pt-2">
            {nodeType !== "parent" ?
              <div className="col-auto ms-auto ">
                <Popconfirm
                  placement="topLeft"
                  title="Are you sure to remove this service?"
                  onConfirm={() => removeServices(node.key, node.type, node.parent)}
                  okText="Yes"
                  cancelText="No"
                >
                  <div className="bg-danger text-white h-auto my-auto fw-bolder px-1">X</div>
                </Popconfirm>
              </div>
              : ""}
            {newNode && nodeType == "parent" ? <div className="col-auto ms-auto ">
              <Popconfirm
                placement="topLeft"
                title="Are you sure to remove this service?"
                okText="Yes"
                cancelText="No"
              >
                <div className="bg-danger text-white h-auto my-auto fw-bolder px-1">X</div>
              </Popconfirm>
            </div>
              : ""}
          </div>
        </div>
      </div>
    );
  };

  function deleteServices(id){
    let inputJson={
      "RoleID" : roleID,
      "EntServiceID" : id
  }
    dispatch(removeRoleService(inputJson));
    setShowsuccessmsg2(true);
  }
  const removeServices = (id, type) => {
    if(newNode==false){
     deleteServices(id);
    }
    if (parentID == 0) {
      let filteredArray = checkedSelectedParent.filter((item) => item != id);
      setCheckedParentSelected(filteredArray);
      let s = roleService;
      for (let i = 0; i < s.length; i++) {
        if (s[i].key == id) {

          if (s[i].children.length > 0) {
            for (let k = 0; k < s[i].children.length; k++) {
              const filteredArray2 = filteredArray.filter((item) => item != s[i].children[k].key);
              filteredArray = filteredArray2;
            }
          }
          const filteredArray1 = s.filter((item) => item.key !== id);
          s = filteredArray1;

        } else {
          if (s[i].children.length > 0) {
            for (let j = 0; j < s[i].children.length; j++) {
              if (s[i].children[j].key == id) {
                s[i].children.splice(j, 1);
              }
            }
          }
        }
      }
      let e = [];
      setRoleService([]);
      for (let k = 0; k < s.length; k++) {
        e.push(s[k]);
      }
      setRoleService(e);
    }
    else {
      let filteredArray = checkedSelectedChild.filter((item) => item != id);
      setCheckedSelectedChild(filteredArray);
      let s = roleServices2;
      for (let i = 0; i < s.length; i++) {
        if (s[i].key == id) {

          if (s[i].children.length > 0) {
            for (let k = 0; k < s[i].children.length; k++) {
              const filteredArray2 = filteredArray.filter((item) => item != s[i].children[k].key);
              filteredArray = filteredArray2;
            }
          }
          const filteredArray1 = s.filter((item) => item.key !== id);
          s = filteredArray1;
        } else {
          if (s[i].children.length > 0) {
            for (let j = 0; j < s[i].children.length; j++) {
              if (s[i].children[j].key == id) {
                s[i].children.splice(j, 1);
              }
            }
          }
        }
      }
      let e = [];
      setRoleServices2([]);
      for (let k = 0; k < s.length; k++) {
        e.push(s[k]);
      }
      setRoleServices2(e);
    }

  }
  const renderTreeNodes1 = (data) =>
    data.map((item) => {
      if (item.children) {
        return (
          <TreeNode className={`${item.type} bg-white`}
            key={item.key}
            title={
              <div className="row w-100 m-0">
                <div className="col-md-6 p-2 assTreeWdh">
                  {item.title}
                </div>
                <div className="col ms-auto pe-1 ">
                  <div className="bg-white desc-box border row pt-2">
                    {newNode && nodeType == "parent" ? <div className="col-auto ms-auto ">
                      <Popconfirm
                        placement="topLeft"
                        title="Are you sure to remove this service?"
                        onConfirm={() => removeServices(item.key, item.type)}
                        okText="Yes"
                        cancelText="No"
                      >
                        <div className="bg-danger text-white h-auto my-auto fw-bolder px-1">X</div>
                      </Popconfirm>
                    </div>
                      : ""}
                    {nodeType !== "parent" ? <div className="col-auto ms-auto ">

                      <Popconfirm
                        placement="topLeft"
                        title="Are you sure to remove this service?"
                        onConfirm={() => removeServices(item.key, item.type)}
                        okText="Yes"
                        cancelText="No"
                      >
                        <div className="bg-danger text-white h-auto my-auto fw-bolder px-1">X</div>
                      </Popconfirm>
                    </div>
                      : ""}
                  </div>
                </div>
              </div>
            }
          >
            {renderTreeNodes1(item.children)}
          </TreeNode>
        );
      }
      return (<TreeNode key={item.key} className={`${item.type} p-2`} title={renderTitle1(item)} />);    
    });
  function getAssociatedRoleService(id,parent) {
    let inputJson = {
      "ProductID" : productID,
      "UserTypeID": parent,
      "RoleID": id  
    }
    dispatch(associatedRoleServices(inputJson));
  }

  const clickTree = (val) => {
    setNewNode(false);
    let path = val.parentName;
    setPathName(path);
    if (val.type == "parent") {
      getUTypeService(val.key);
    } else if (val.type == "sub-parent") {
      getUTypeService(val.parent);
      getURoleService( val.key);
      getAssociatedRoleService(val.key,val.parent);
      setRoleID(val.key);
    } else {
      getUTypeService(val.parent);
      getURoleService( val.key);
      getAssociatedRoleService(val.key, val.parent);
      setRoleID(val.key);
    }
    setRowData(val);
    // console.log("parent",val);
    setNodeType(val.type);
    if (val.type == "sub-parent" || val.type == "child") {
      form.setFieldsValue({
        roleName: val.title,
        roleDesc: val.desc
      })
    }
  }
  const addChildNode = (val) => {
    // console.log(val, "adding chld")
    let path = val.parentName;
    setPathName(path);
    if (val.type == "parent") {
      getUTypeService(val.key);
      setParentID(val.key);
      setReportID(0);
    } else if (val.type == "sub-parent") {
      setParentID(val.parent);
      setReportID(val.key);
      getUTypeService(val.parent);
      getURoleService(val.parent)
    }
    else {
      setParentID(val.parent);
      setReportID(val.key);
      getUTypeService(val.parent);
      getURoleService(val.parent);
    }
    setRoleID(0);
    setRowData(val);
    // if(nodeType=="parent"){
    //   setNode
    // }
    setNewNode(true);
    setNodeType(val.type);
    // if(val.type=="sub-parent"|| val.type=="child"){
    form.setFieldsValue({
      roleName: "",
      roleDesc: ""
    })
    // }
  }
  const [isManager, setIsManager] = useState(true)
  const handleManagericalChange = (e) =>{
    setIsManager(e)
  }
 
  const submitForm = (values) => {
    let selectedValues = [];
    if (nodeType == "parent") {
      selectedValues = checkedSelectedParent;
    }
    else {
      selectedValues = checkedSelectedChild;
    }
    // console.log(values, "values")
    let inputJson = {
      "RoleID": roleID,
      "RoleName": values.roleName,
      "RoleDescription": values.roleDesc,
      "ReportToRoleID": reportID || 0,
      "RoleCategory": rowData?.RoleCategory,
      "TenantID": tenantID,
      "ProductID": productID,
      "UserTypeID": parentID,
      "EntServices": selectedValues.toString(),
      "IsManager":isManager,
    }
    dispatch(addRoleService(inputJson));
    setShowsuccessmsg(true);
  }
  const submitForm1 = () => {
    const value = form.getFieldsValue();
    let selectedValues = [];
    if (nodeType == "parent") {
      selectedValues = checkedSelectedParent;
    }
    else {
      selectedValues = checkedSelectedChild;
    }
    let inputJson = {
      "RoleID": roleID,
      "RoleName": rowData.title,
      "RoleDescription": rowData.desc,
      "ReportToRoleID": reportID || 0,
      "RoleCategory":rowData?.RoleCategory,
      "TenantID": tenantID,
      "ProductID": productID,
      "UserTypeID": rowData?.parent,
      "EntServices": selectedValues.toString(),
      "IsManager":isManager,
    }
    dispatch(addRoleService(inputJson));
    setShowsuccessmsg(true);
    onClose();
  }
  
  useEffect(() => {
    if (successmsg) {
      if(addRoleInfo?.message == "Role Created Successfully" && roleID==0){
        message.success("Role Created successfully");
        getAssociatedRoleService(rowData.key, rowData.parent);
        setShowsuccessmsg(false);
        form.resetFields();
      }
      else {
        message.success("Role updated successfully");
        getAssociatedRoleService(rowData.key, rowData.parent);
        setShowsuccessmsg(false);
      }
      getUserRoleType();
      getUTypeService(roleID);
      getURoleService(roleID);
    }
  }, [successmsg]);
  useEffect(() => {
    if (successmsg2) {
      message.success("Role Service Deleted successfully");
      getAssociatedRoleService(rowData.key, rowData.parent);
      setShowsuccessmsg2(false);
      getUserRoleType();
      getUTypeService(roleID);
      getURoleService(roleID);
    }
  }, [successmsg2]);

  useEffect(() => {
    if (successmsg1) {
      if(delUserInfo?.message == 'Could not deleted associated another instance' ){
        message.warning(delUserInfo.message)
      }
      else{
        message.success("Role deleted successfully");
        getUserRoleType();
        setNodeType("parent");
        setNewNode(false)
        setHasExecuted(true)
        setShowsuccessmsg1(false);
      }
    }
  }, [successmsg1]);

  const getUserRoleType = () => {
    dispatch(getUserTypeRl(tenantID));
  }

  const onClose = () => {
    setOpen(false);
  }
  const onOpen = () => {
    setOpen(true);
  }
  

  const renderTreeNodes2 = (data) =>
    data.map((item) => {
      if (item.children) {
        return (
          <TreeNode className={`${item.type} bg-white`}
            key={item.key}
            title={
              <div className="row w-100 m-0">
                <div className="col-auto p-2">
                  {item.title}
                </div>
                <div className="col-auto ms-auto pe-1">
                  {/* <PlusOutlined className="plus-icon bg-primary text-white" /> */}
                </div>
              </div>
            }
          >
            {renderTreeNodes2(item.children)}
          </TreeNode>
        );
      }
      return (<TreeNode className={`${item.type}`} key={item.key} title={<div className="p-2">{item.title}</div>} />);
    });
  const onCheck1 = (checkedKeys, info) => {
    setCheckedSelectedChild(checkedKeys.checked);
    // console.log(checkedSelectedChild,"checkedSelectedChild");
  }
  const renderTreeNodes4 = (data) =>
    data.map((item) => {
      if (item !== undefined && item.children) {
        return (
          <TreeNode className={`${item.type} bg-white`}
            key={item.key}
            title={
              <div className="row w-100 m-0">
                <div className="col-auto p-2">
                  {item.title}
                </div>
                <div className="col-auto ms-auto pe-1">

                </div>
              </div>
            }
          >
            {renderTreeNodes4(item.children)}
          </TreeNode>
        );
      }

      return (<TreeNode className={`${item.type}`} key={item.key} title={<div className="p-2">{item.title}</div>} />);
    });

  return (
    <>
      <div className="mt-2 user-role p-3">
        <Card className="border-0" >
          <div className='row mb-2'>
            <div className='col-md-3 text-start ms-1 bg-light'>
              <h6>User Roles</h6>
              {userService ?
                <div className="user-role-h fix-h">
                  <Tree
                    // checkable
                    defaultExpandAll
                    // onSelect={onSelect}
                    // onCheck={onCheck}
                    className="draggable-tree1"
                    // treeData={roleService}
                    blockNode>{renderTreeNodes(userService)}</Tree>
                </div> : ""}
              {/* <Tree
                defaultExpandAll
                className="draggable-tree1"
                blockNode>{renderTreeNodes(userService)}</Tree> */}
            </div>
            <div className="col">
              {nodeType == "parent" && !newNode ? <>
                <div className="bg-blue p-3">
                  <span className="fw-bold">User Type</span>: {rowData ? rowData.commonName || rowData?.title : ""}<br />
                  <span className="fw-bold">Description</span>: {rowData ? rowData.description || rowData?.desc : ""}
                </div>
                <div className="mt-5">
                  <h6 className="">Following are features & services associated with this user type</h6>
                  <div className="row m-0 w-100 bg-light mt-4">
                    <div className="col-md-6  p-2 ps-4 fs-6 fw-bolder ">Service Name </div>
                    <div className="col-md-6 p-2 ps-5 fs-6 fw-bolder">Description </div>
                    {/* <div className="d-flex"> */}
                    {roleService2 ?
                      <div className="green-tree service-tree px-0">
                        <Tree
                          checkable
                          disabled
                          defaultExpandAll
                          // onSelect={onSelect}
                          // onCheck={onCheck}
                          className="draggable-tree1"
                          // treeData={roleService}
                          blockNode>{renderTreeNodes3(roleService2)}</Tree>
                      </div>
                      : ""}
                  </div>
                </div>
              </> :
                <div>
                  <div className="bg-light p-2 mb-3">
                    <h6>Add/Edit Role</h6>
                  </div>
                  <div className="d-flex">
                    <h6 className="me-2">Role Path:</h6>
                    <Breadcrumb>
                      <Breadcrumb.Item>User Type: {pathName}</Breadcrumb.Item>
                    </Breadcrumb>
                    {/* <Breadcrumb items={[{'User Type': {pathName}}]}/> */}
                  </div>
                  <Form layout="vertical" form={form}
                    onFinish={submitForm}>
                    <div className="row">
                      <Form.Item label="Role Name" name="roleName" className="col-4">
                        <Input />
                      </Form.Item>
                      <Form.Item label="Role Description" name="roleDesc" className="col-4">
                        <Input />
                      </Form.Item>
                      <Form.Item label="" name="isManagerical" className="col-auto d-flex align-items-end">
                        <div className="d-flex isManagerical">
                          <label className="ms-2 me-3">Is This Role is Managerial Role?</label>
                          <Switch  onChange={handleManagericalChange}/>
                        </div>
                      </Form.Item>
                    </div>
                    <div className="mt-3 mb-2 d-flex">
                      <h6 className="">Following are features & services associated with this user type</h6>
                      {newNode ? "" : <Button type="primary" className="ms-auto" onClick={onOpen}>+ Associate Feature/Services</Button>}
                    </div>
                    <div className="row w-100 bg-light ms-1 mt-3 border-bottom"> 
                          <div className="col-md-6  p-2 ps-4 fs-6 fw-bold ">Service Name </div>
                          <div className="col-md-6 p-2 ps-5 fs-6 fw-bold">Description </div>
                    </div>
                    {newNode ?
                      <div>
                        {nodeType == "parent" && newNode ? <> {roleService ?
                          <div className="green-tree service-tree ">
                            <Tree
                              checkable
                              defaultExpandAll
                              // onSelect={onSelect}
                              // onCheck={onCheck}
                              className="draggable-tree1"
                              // treeData={roleService}
                              
                              blockNode>{renderTreeNodes1(roleService)}</Tree>
                          </div>
                          : <div className="col-md-12 bg-light text-center fw-bold fs-6 p-3">No service associated with this Role</div>}</> : <>
                          {roleService ?
                            <div className="green-tree service-tree ">
                              <Tree
                                checkable
                                // disabled
                                defaultExpandAll
                                // onSelect={onSelect}
                                // onCheck={onCheck}
                                className="draggable-tree1"
                                // treeData={roleService}
                                blockNode>{renderTreeNodes1(roleService)}</Tree>
                            </div>
                            : <div className="col-md-12 bg-light text-center fw-bold fs-6 p-3">No service associated with this Role</div>}
                        </>}
                      </div> :
                      <>
                        {assService ?
                          <div className="green-tree service-tree ">
                            <Tree
                              checkable
                              // disabled
                              defaultExpandAll
                              // onSelect={onSelect}
                              // onCheck={onCheck}
                              className="draggable-tree1"
                              // treeData={roleService}
                              blockNode>{renderTreeNodes1(assService)}</Tree>
                          </div>
                          : <div className="col-md-12 bg-light text-center fw-bold fs-6 p-3">No service associated with this Role</div>}
                      </>}
                    <div className="row m-0 text-end mt-3">
                      <Button type="primary" className="col-auto ms-auto dlv-save-btn" htmlType="submit">Save</Button>
                    </div>
                  </Form>
                </div>}
            </div>
          </div>
        </Card>
      </div>

      <Drawer
        title="Update Feature/Services"
        width={550}
        onClose={onClose}
        open={open}
        bodyStyle={{ paddingBottom: 80 }}
        destroyOnClose={true}
      >
        <div className="bg-blue p-2 mb-2">
          <div><span className="fw-bold">Role Name:</span><span>{rowData.title}</span></div>
          <div><span className="fw-bold">Role Description:</span><span>{rowData.desc}</span></div>
        </div>
        <div>
          {checkService ?
            <div className="green-tree service-tree ">
              <Tree
                checkable
                defaultExpandAll
                checkStrictly
                defaultCheckedKeys={checkedKeys}
                // onSelect={onSelect}
                onCheck={onCheck1}
                className="draggable-tree1"
                // treeData={roleService}
                blockNode>{renderTreeNodes4(checkService)}</Tree>
            </div>
            : ""}
        </div>
        <div className="row m-0 text-end mt-3">
          <Button type="primary ms-auto cancel-btn" danger className="col-auto ms-auto me-1 dlv-cancel-btn" onClick={onClose}>Cancel</Button>
          <Button type="primary" className="col-auto dlv-save-btn" onClick={submitForm1}>Save</Button>
        </div>
      </Drawer>
    </>
  )
}


